"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ShareButtons_1 = __importDefault(require("./ShareButtons"));
const utils_1 = require("../../../helpers/utils");
const AwardWithBackground_1 = require("./AwardWithBackground/AwardWithBackground");
const AwardColors_1 = require("./config/AwardColors");
const react_query_1 = require("@tanstack/react-query");
const Modal_1 = require("../../../components/Modal/Modal");
const AwardModal = ({ open, award, onCloseCallback }) => {
    const [modalOpen, setModalOpen] = (0, react_1.useState)(open);
    const queryClient = (0, react_query_1.useQueryClient)();
    const closeModal = (0, react_1.useCallback)(() => {
        setModalOpen(false);
        onCloseCallback();
        document.body.style.overflow = 'unset';
        if (modalOpen) {
            queryClient.invalidateQueries({ queryKey: ['get-donations'] });
        }
    }, [modalOpen, onCloseCallback, queryClient]);
    (0, react_1.useEffect)(() => {
        document.body.style.overflow = open ? 'hidden' : 'unset';
    }, [open]);
    const specialYears = [10, 20, 30, 40, 50, 60];
    const getAwardHeadingText = (award) => {
        if (award.heading && award.obtainedAt) {
            if (award.category === 'endurance' && specialYears.includes(award.requiredValue)) {
                return `${__.trans(`awards.special-years-heading`, { numYears: award.requiredValue })}`;
            }
            return `${__.trans(`awards.${award.heading}`, { numYears: award.requiredValue })}`;
        }
        if (!award.obtainedAt) {
            if (award.notObtainedHeading) {
                return `${__.trans(`awards.${award.notObtainedHeading}`)}`;
            }
            if (award.notObtainedText) {
                return `${__.trans(`awards.${award.notObtainedText}`)}`;
            }
        }
        return '';
    };
    const getAwardText = (award) => {
        if (award.obtainedAt && award.text) {
            if (award.category === 'endurance' && specialYears.includes(award.requiredValue)) {
                return `${__.trans(`awards.special-years`)}`;
            }
            return `${__.trans(`awards.${award.text}`)}`;
        }
        if (!award.obtainedAt && award.notObtainedHeading && award.notObtainedText) {
            return `${__.trans(`awards.${award.notObtainedText}`)}`;
        }
        return '';
    };
    const link = () => {
        return 'https://e-tjanster.1177.se/mvk/facilityContactCard.xhtml?hsaId=SE2321000016-DQWZ&amp;selecting=false';
    };
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { isOpen: open, centered: true, toggle: closeModal, "aria-label": __.trans('aria.award'), id: "awards-modal", children: (0, jsx_runtime_1.jsx)("div", { className: "p-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "award-modal-body-content", style: { backgroundColor: '#fff' }, children: [(0, jsx_runtime_1.jsx)("button", { className: "close-button", onClick: closeModal, "aria-label": __.trans('aria.close-modal'), children: "x" }), (0, jsx_runtime_1.jsxs)("div", { className: "text-content ", children: [(0, jsx_runtime_1.jsx)("h2", { style: { color: AwardColors_1.COLORS[(0, utils_1.getAwardColor)(award)].darkColor }, children: getAwardHeadingText(award) }), (0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: {
                                    __html: getAwardText(award),
                                } }), award.obtainedAt && award.showLink && ((0, jsx_runtime_1.jsxs)("p", { children: [__.trans('awards.contact-link-text'), ' ', (0, jsx_runtime_1.jsxs)("a", { target: "_blank", href: link(), children: [__.trans('awards.contact-link-click-text'), ' '] })] })), !award.obtainedAt && award.key === 'webbooking' && ((0, jsx_runtime_1.jsxs)("p", { children: [__.trans('awards.webbooking-not-obtained-link'), ' ', (0, jsx_runtime_1.jsxs)("a", { target: "_blank", href: link(), children: [__.trans('awards.contact-link-click-text'), ' '] })] })), award.obtainedAt && ((0, jsx_runtime_1.jsx)(ShareButtons_1.default, { award: award, color: AwardColors_1.COLORS[(0, utils_1.getAwardColor)(award)].darkColor }))] }), (0, jsx_runtime_1.jsx)(AwardWithBackground_1.AwardWithBackground, { award: award, color: (0, utils_1.getAwardColor)(award), "aria-label": __.trans('aria.award') })] }) }) }));
};
exports.default = AwardModal;
